import React from "react";
import axios from "axios";
import { Navigate } from 'react-router-dom';

export class PaginationLinks extends React.Component {
  render() {
    const { from, to, total_no_of_item, links, paginationFetch } = this.props;
    const previous = "relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0";
    const next = "relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0";
    const numberV = "relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0";
    const currentV = "relative z-10 inline-flex items-center bg-indigo-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600";

    const previousLabel = (
      <>
        <span className="sr-only">Previous</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
          <path fillRule="evenodd"
                d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z"
                clipRule="evenodd"/>
        </svg>
      </>
    );

    const nextLabel = (
      <>
        <span className="sr-only">Next</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
          <path fillRule="evenodd"
                d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z"
                clipRule="evenodd"/>
        </svg>
      </>
    );

    return (
      <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
     
        <div className="flex flex-1 justify-between sm:hidden">
          <a
            key={333}
            onClick={() => {
              paginationFetch(links[0].url);
            }}
            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
            Previous
          </a>
          <a
            key={444}
            onClick={() => {
              paginationFetch(links[links.length - 1].url);
            }}
            className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
            Next
          </a>
        </div>
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-700">
              Showing{" "}
              <span className="font-medium">{from}</span>{" "}
              to{" "}
              <span className="font-medium">{to}</span>{" "}
              of{" "}
              <span className="font-medium">
                {total_no_of_item}
              </span>{" "}
              results
            </p>
          </div>
          <div>
            <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
              {links.map((link, index) => (
                <a
                  key={index}
                  onClick={() => {
                    paginationFetch(link.url);
                  }}
                  {...(link.active ? {"aria-current": "page"} : {})}
                  className={link.active ? currentV : link.label === "Previous" ? previous : link.label === "Next" ? next : numberV}
                >
                  {link.label === "Previous" ? previousLabel : link.label === "Next" ? nextLabel : link.label}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export const renderProgressDialog = ({whenNotSearch = true}) => {

    return (
        <div
            className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 ${whenNotSearch ? 'z-50' : 'z-10'}`}>
            <div className="bg-white p-4 rounded-md">
                <div className="flex items-center justify-center">
                    <div
                        className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                </div>
                <p className="text-center mt-4">Loading...</p>
            </div>
        </div>
    );
};



const DataDisplayOne = ({ title, dataOneList }) => {
    return (
        <div className="mt-7">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
                {title}
            </h3>
            <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                {dataOneList.map((item) => (
                    <div key={item.name} className="px-4 py-5 sm:p-6">
                        <dt className="text-base font-normal text-gray-900">
                            {item.name}
                        </dt>
                        <dd className="mt-1 flex text-center justify-between items-baseline md:block lg:flex">
                            <div className="flex text-center items-baseline text-1xl font-semibold text-indigo-600">
                                RS: {item.stat}
                                <span className="ml-2 text-sm font-medium text-gray-500"> </span>
                            </div>
                        </dd>
                    </div>
                ))}
            </dl>
        </div>
    );
};

export default DataDisplayOne;


export const DataDisplayTwo = ({ title, dataOneList }) => {
    return (
        <div className="mt-7">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
                {title}
            </h3>
            <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                {dataOneList.map((item) => (
                    <div key={item.name} className="px-4 py-5 sm:p-6">
                        <dt className="text-base font-normal text-gray-900">
                            {item.name}
                        </dt>
                        <dd className="mt-1 flex text-center justify-between items-baseline md:block lg:flex">
                            <div className="flex text-center items-baseline text-1xl font-semibold text-indigo-600">
                                 {item.stat}
                                <span className="ml-2 text-sm font-medium text-gray-500"> </span>
                            </div>
                        </dd>
                    </div>
                ))}
            </dl>
        </div>
    );
};




export const makeApiRequest = async (url, method = 'GET', data = null, headers = {}, params = {}) => {
    try {
        const authToken = localStorage.getItem('token');
        const defaultHeaders = {
            Authorization: `Bearer ${authToken}`,
            Accept: 'application/json',
        };

        const response = await axios({
            method,
            url,
            params,
            data,
            headers: {...defaultHeaders, ...headers},
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};


export const InputField = ({label, type, name, value, onChange, error, withStar}) => {

    return (
        <div>
            <label
                htmlFor={name}
                className="block text-sm font-medium text-gray-700">
                    <span
                        className={`${withStar ? 'after:content-["*"] ' : ''} after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700`}>
                       {label}
                    </span>
            </label>
            <input
                type={type}
                name={name}
                id={name}
                value={value}
                onChange={onChange}
                autoComplete={name}
                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
            />
            {error && (
                <p className="mt-2 text-sm text-red-600" id={`${name}-error`}>
                    {error}
                </p>
            )}
        </div>
    );
};


export const ButtonOne = ({ onClick, label }) => {
    return (
        <button
            onClick={onClick}
            type="button"
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
        >
            {label}
        </button>
    );
};





export const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');

    if (token == null) {
        return <Navigate to="/Login" />;
    }

    return children;
};






